// eslint-disable
const { handleHeader } = require('./corpHeaderFooter/handleHeader');

// Find the two letter lang code for the selected lang

const normalizeLang = (lang) => {
    let langClass;

    switch (lang) {
        case 'English – US':
            langClass = 'us';
            break;
        case 'Deutsch':
            langClass = 'de';
            break;
        case 'Portuguese':
            langClass = 'pt';
            break;
        case '简体中文':
            langClass = 'cn';
            break;
        case 'Français':
            langClass = 'fr';
            break;
        case 'Italiano':
            langClass = 'it';
            break;
        case 'Русский':
            langClass = 'ru';
            break;
        case 'Nederlands':
            langClass = 'nl';
            break;
        case '日本語':
            langClass = 'jp';
            break;
        case 'Español':
            langClass = 'es';
            break;
        default:
            langClass = 'en';
            break;
    }

    return langClass;
};
const bindLangToggleSetDefault = (defaultLang) => {
    document.querySelector('body').classList.add(`ob-lang-${normalizeLang(defaultLang)}`);
    window.currentLang = normalizeLang(defaultLang);
    if(document.querySelector('meta[name="uberflip:hub_id"]')){
    const hubId = document.querySelector('meta[name="uberflip:hub_id"]').content;
    /* Uberflip GWL OB-9206 start here */
    if (hubId !== '130690') {
        handleHeader(window.currentLang);
    }
    /* Uberflip GWL OB-9206 end here */
}
};

module.exports = { bindLangToggleSetDefault };


// WEBPACK FOOTER //
// ./scriptPartials/lang-toggle.js